

































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
class  PageLockingRequest extends PageRequest{
    keyword:string;
    fromDate: Date;
    toDate: Date;
}

@Component
export default class LocationLocking extends mixins(ListMixin, AbpBase){
    namespace = 'locationLocking';
    pagerequest:PageLockingRequest=new PageLockingRequest();
     creationTime:Date[]=[];
    get store () {
      return this.$store.state.locationLocking;
    }
    isTenant() {
      return this.$store.state.session.tenant != null;
    }
    preGetPage () {
        if (this.creationTime.length>0) {
            this.pagerequest.fromDate=this.creationTime[0];
        }
        if (this.creationTime.length>1) {
            this.pagerequest.toDate=this.creationTime[1];
        }
    }
    get list(){
      var re = this.$store.state.locationLocking.list;
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var index = 0;
      re.forEach(function(item) {
        item.orderNo = startIndex + index + 1;
        index++;
      });
      return re;
    }
    columns= [
         {
              title:Util.L('Order'),
              width: 90,
              key:'orderNo'
          },
          {
              title:Util.L('Name'),
              width: 200,
              key:'name'
          },
          {
              title:Util.L('LocationType'),
              key:'locationTypeName'
          },
          {
              title:Util.L('LockTime'),
              key:'lockTime',
              render:(h:any,params:any)=>{
                  if(Util.isNull(params.row.lockTime))
                  return '';
                  return h("span", Util.toViewDateString(params.row.lockTime));
              }
          },
          {
              title:Util.L('UnLockTime'),
              key:'unlockTime',
               render:(h:any,params:any)=>{
                  if(Util.isNull(params.row.unLockTime))
                  return '';
                  return h("span", Util.toViewDateString(params.row.unLockTime));
              }
          },
          {
              title:Util.L('CreationTime'),
              key:'creationTime',
              render:(h:any,params:any)=>{
                  return h("span", Util.toViewDateString(params.row.creationTime));
              }
          },
           {
              title:Util.L('Action'),
              slot:'action',
              align: "center"
          }
        ]
    async created(){
       
    }
}
